/**
 * Created by Simone.Sacchi on 01/08/2016.
 */

"use strict";
try {
    require("website_design_system");
} catch (e) {}

require("index.css");



var ClientStorage = require("Base/ClientStorage");
var baseConfig = require("Base/config");
var utils = require("Base/utils");
var ConcurrentUsers = require("Base/ConcurrentUsers");


window._ = {};
window._.extend = require("lodash/extend");
window._.each = require("lodash/each");
window._.isEmpty = require("lodash/isEmpty");
window._.uniq = require("lodash/uniq");
window._.isObject = require("lodash/isObject");
window._.isEqual = require("lodash/isEqual");
window._.filter = require("lodash/filter");
window._.escape = require("lodash/escape");
window._.difference = require("lodash/difference");
window._.sortBy = require("lodash/sortBy");
window._.find = require("lodash/find");


$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    /**
     * Strip XSSI protecting prefix from JSON using jQuery ajaxBefore - prefix is "for (;;);"
     *
     * @link https://gist.github.com/simonw/46695d184096e917c3897d6b8ec20de3
     *
     * @param {string} response
     * @returns {string} response with out prefix
     *
     * @author Simone Sacchi
     * @version 2018/10/17
     */
    dataFilter: function (response) {
        response = response.replace(/^for \(;;\);/, '');

        return response;
    }
});

//define the base url
var _baseUrl = window.Swiftref.base_url;



/*
 *
 *  Concurrent users check
 *
 *
 */
// INSTITUTION DETAILS - tab and link
$("#search__details__content--institutions").on("mousedown", function (e) {
    // set default page
    var requestedPage = 'institutions_institution_profile';

    var element = e.target.tagName;

    if (element == 'A' ||
        element == 'SELECT' ||
        element == 'INPUT' ||
        (element === 'TR' && e.target.getAttribute('data-acronym'))
    ) {

        if (e.target.getAttribute('aria-controls')) {
            requestedPage = ConcurrentUsers.mappingRequestedPage.institution_details[e.target.getAttribute('aria-controls')];
        }

        ConcurrentUsers.check(e, requestedPage, function () {
            // set default element to hidden
            $('#search__details__tab_content--institutions_institution_profile').html('');

            $('#search__details__tab_content--' + requestedPage).html('');

        }, '#search__details__tab_content--' + requestedPage);
    }
});


// SSIS DETAILS - tab and link
$("#search__details__content--ssis").on("mousedown", function (e) {
    var element = e.target.tagName;

    if (element == 'A' ||
        element == 'SELECT' ||
        element == 'INPUT'
    ) {
        var requestedPage = ConcurrentUsers.mappingRequestedPage.ssis_details;
        ConcurrentUsers.check(e, requestedPage, function () {

            $("#search__details__tab_content--ssis_content").html('');

            if (element == 'A' && $(e.target).hasClass('default_link')) {
                setTimeout(function () {
                    window.location.href = _baseUrl + "/" + window.Swiftref.lang + "/home";
                }, 5000);
            }
        }, '#search__details__tab_content--ssis_content');
    }

});

// PAYMENT SYSTEM DETAILS
$("#search__details__content--payment_systems").on("mousedown", function (e) {

    var element = e.target.tagName;

    if (element == 'A' ||
        element == 'SELECT' ||
        element == 'INPUT'
    ) {
        var requestedPage = ConcurrentUsers.mappingRequestedPage.payment_systems_details;
        ConcurrentUsers.check(e, requestedPage, function () {

            $("#payment_system_details").html('');
            $("#payment_systems_details_table__records").html('');
            $("#payment_systems_details_table__pagination").html('');

        }, '#payment_system_details');
    }

});


// Countries currencies details - tab
$("#search__details__tabs--countries_currencies").on("mousedown", function (e) {
    var element = e.target.tagName;

    if (element == 'A' ||
        element == 'SELECT' ||
        element == 'INPUT' ||
        (element === 'TR' && e.target.getAttribute('data-acronym'))

    ) {
        var requestedPage = ConcurrentUsers.mappingRequestedPage['countries_currencies'];
        var divContainer = e.target.getAttribute('aria-controls');

        ConcurrentUsers.check(e, requestedPage, function () {
            // hide the first item
            $('#details_countries_currencies__main_information').html('');

            $('#details_countries_currencies__' + divContainer).html('');

        }, '#details_countries_currencies__' + divContainer);
    }


});


try {
    document.querySelector("#copy-year").innerText = new Date().getFullYear();
    var newFeedbackButton = document.getElementById("new-feedback-button");
    newFeedbackButton.addEventListener("click", function (e) {
        e.preventDefault();
        try {
            // public pages (e.g.: sepaio) does not have feedback button
            document.getElementById("old-feedback-button").click();
        } catch (e) {}

    });

} catch (e) {}

module.exports = {

    // fake clientStorage API in case if clientStorage is disabled
    //clientStorage :  window.sessionStorage ? window.sessionStorage : {
    //    setItem : function () {},
    //    getItem : function () {},
    //    clear : function () {}
    //},
    clientStorage: ClientStorage,

    getCsrfToken: utils.getCsrfToken,
    ENTER_KEY: 13,
    OK: "OK",
    baseUrl: _baseUrl,

    loadConfig: function (pageConfig) {

        this.config = {};

        // Retrieve data and config printed by the server.
        if (window.Swiftref) {
            _.extend(this, window.Swiftref);

            // merge laravel/config with js config file (if any)
            if (window.Swiftref.config) {
                _.extend(this.config, window.Swiftref.config);
                delete window.Swiftref.config;
            }
        }

        // load client base config
        _.extend(this.config, baseConfig);

        if (pageConfig && _.isObject(pageConfig)) {
            _.extend(this.config, pageConfig);
        }


    },
    clone: function (obj) {
        try {
            return JSON.parse(JSON.stringify(obj));
        } catch (e) {
            return obj;
        }
    }
};



